import React from 'react';
import Markdown from 'react-markdown';
import RouterLink from './router-link';

const defaultRenderers = { Link: RouterLink };

export default function MarkdownComponent({ renderers = {}, ...props }) {
  return (
    <Markdown renderers={{ ...defaultRenderers, ...renderers }} {...props} />
  );
}
